import { useState } from "react";
import { useNavigate } from "react-router";
import { apiUrl } from "@/lib/api";
import { getAccessToken } from "@/lib/auth";
import { clearImpersonation, getImpersonation } from "@/lib/impersonation";
import { useAuth } from "@/lib/hooks/useAuth";

export function ImpersonationBanner() {
  const { impersonating } = useAuth();
  const navigate = useNavigate();
  const [stopping, setStopping] = useState(false);

  if (!impersonating) return null;

  const stop = async () => {
    setStopping(true);
    const target = getImpersonation();
    clearImpersonation();
    try {
      const token = await getAccessToken();
      const headers: Record<string, string> = {};
      if (token) headers.Authorization = `Bearer ${token}`;
      const qs = target ? `?user_id=${encodeURIComponent(target.user_id)}` : "";
      await fetch(apiUrl(`/api/admin/impersonate${qs}`), {
        method: "DELETE",
        headers,
      });
    } catch {
      /* clearing local state is the source of truth — audit row is best-effort */
    } finally {
      setStopping(false);
      navigate("/admin");
    }
  };

  const label = impersonating.full_name
    ? `${impersonating.full_name} (${impersonating.email})`
    : impersonating.email || impersonating.user_id;

  return (
    <div className="sticky top-0 z-[60] flex items-center gap-3 border-b border-amber-300 bg-amber-100 px-4 py-2 text-sm text-amber-900 shadow-sm">
      <span className="rounded bg-amber-300 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-amber-950">
        Impersonatie
      </span>
      <span className="truncate">
        Bekijken als <strong>{label}</strong> — alleen lezen
        {impersonating.organization_name ? ` · ${impersonating.organization_name}` : ""}
      </span>
      <button
        type="button"
        onClick={() => void stop()}
        disabled={stopping}
        className="ml-auto rounded-md border border-amber-400 bg-white px-3 py-1 text-xs font-medium text-amber-900 hover:bg-amber-50 disabled:opacity-50"
      >
        {stopping ? "Stoppen…" : "Stop"}
      </button>
    </div>
  );
}
